import axios from "axios";

// FE-77 (21.10.2026): ortak API olayları. Services.js'te 236 ayrı axios çağrısı var; ortak 401/oturum ve hata
// yönetimi yoktu, 51 boş catch yüzünden "yüklenemedi" ile "veri yok" aynı görünüyordu. Tek yerden:
//  - Kullanıcının KENDİ token'ıyla giden istek "Invalid token" dönerse (API HTTP 200 + status:false döndürür)
//    oturum bitmiştir → "oturum-dustu" olayı (App çıkış yaptırıp giriş ekranına götürür). Misafir token'ıyla
//    çalışan giriş/teklif/davet sayfaları etkilenmez (token kullanıcınınkiyle eşleşmez).
//  - Ağ hatası (yanıt yok) ya da 5xx → "api-baglanti-hatasi" olayı (App kısa bir uyarı gösterir). İptal edilen
//    istekler sayılmaz. Sayfaların kendi hata işleyişi DEĞİŞMEZ; bu yalnız ek bir bildirim.
//  - 26.10.2026 (güvenlik manifesti A1/A3/A5): BE'nin yeni İngilizce ret yanıtları ekrana ham çıkmasın diye
//    message Türkçeye çevrilir (asıl metin messageRaw'da kalır): "You do not have permission" → "Bu işlem için
//    yetkiniz yok.", "Too many requests …" (SMS / şifre sıfırlama sınırları) → "Çok fazla deneme yapıldı, …".
export const YETKI_YOK_MESAJI = "Bu işlem için yetkiniz yok.";
export const COK_DENEME_MESAJI = "Çok fazla deneme yapıldı, lütfen daha sonra tekrar deneyin.";

/** Ham API mesajını kullanıcı metnine çevirir; tanınmayan mesaj aynen döner. */
export function apiMesajiCevir(m) {
  const s = String(m ?? "");
  if (/you do not have permission/i.test(s)) return YETKI_YOK_MESAJI;
  if (/too many requests/i.test(s)) return COK_DENEME_MESAJI;
  return s;
}
export const cokDenemeMi = (m) => /too many requests|çok fazla deneme/i.test(String(m ?? ""));

let kuruldu = false;
let sonOturumOlayi = 0;
let sonHataOlayi = 0;

function kullaniciToken() {
  try { return sessionStorage.getItem("token") || localStorage.getItem("token") || ""; } catch (e) { return ""; }
}
function istekToken(config) {
  const h = config?.headers || {};
  const a = String(h.Authorization || h.authorization || "");
  return a.replace(/^Bearer\s+/i, "").trim();
}
function yay(ad) {
  try { window.dispatchEvent(new CustomEvent(ad)); } catch (e) { /* yoksay */ }
}

export function installApiOturum() {
  if (kuruldu) return;
  kuruldu = true;
  axios.interceptors.response.use(
    (res) => {
      const d = res?.data;
      if (d && d.status === false && typeof d.message === "string") {
        const tr = apiMesajiCevir(d.message);
        if (tr !== d.message) {
          d.messageRaw = d.message;
          d.message = tr;
        }
      }
      if (d && d.status === false && /invalid token/i.test(String(d.message || ""))) {
        const t = kullaniciToken();
        if (t && istekToken(res.config) === t && Date.now() - sonOturumOlayi > 5000) {
          sonOturumOlayi = Date.now();
          yay("oturum-dustu");
        }
      }
      return res;
    },
    (err) => {
      if (!axios.isCancel(err)) {
        const kod = err?.response?.status;
        if ((!err?.response || kod >= 500) && Date.now() - sonHataOlayi > 10000) {
          sonHataOlayi = Date.now();
          yay("api-baglanti-hatasi");
        }
      }
      return Promise.reject(err);
    }
  );
}
